(function _auGuardCartImages() {
  const SEL = '.cart__image--img[data-au-locked-src]';
  const ATTR = 'data-au-locked-src';
  const BAD = '/uploads/';

  function _fix(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(SEL).forEach((img) => {
      if (img.src.indexOf(BAD) !== -1) img.src = img.getAttribute(ATTR);
    });
  }

  const target = document.querySelector('[data-products]') || document.body;

  const obs = new MutationObserver((mutations) => {
    for (let i = 0, len = mutations.length; i < len; i++) {
      const m = mutations[i];
      if (m.type === 'attributes') {
        const img = m.target;
        if (img.src.indexOf(BAD) !== -1) img.src = img.getAttribute(ATTR);
      } else if (m.type === 'childList') {
        const added = m.addedNodes;
        for (let j = 0, jLen = added.length; j < jLen; j++) {
          const n = added[j];
          if (n.nodeType === 1) _fix(n);
        }
      }
    }
  });
  obs.observe(target, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src'],
  });

  document.addEventListener('cart:updated', () => {
    requestAnimationFrame(() => _fix(target));
    setTimeout(() => _fix(target), 300);
  });
})();

const AU_TERMS_STORAGE_KEY = 'cart_terms_accepted';

function getStoredTermsState() {
  try {
    return sessionStorage.getItem(AU_TERMS_STORAGE_KEY) === 'true';
  } catch (_) {
    return false;
  }
}

function setStoredTermsState(isChecked) {
  try {
    if (isChecked) {
      sessionStorage.setItem(AU_TERMS_STORAGE_KEY, 'true');
    } else {
      sessionStorage.removeItem(AU_TERMS_STORAGE_KEY);
    }
  } catch (_) {}
}

function cartTermsLabelPulse() {
  function syncTermsState() {
    const isAccepted = getStoredTermsState();
    const checkboxes = document.querySelectorAll('.cart__terms-checkbox');

    checkboxes.forEach((cb) => {
      if (cb.checked !== isAccepted) {
        cb.checked = isAccepted;
      }
    });

    document.querySelectorAll('.cart__checkout').forEach((btn) => {
      if (btn.classList.contains('cart__checkout--loading')) return;

      const textEl = btn.querySelector('.cart__checkout-text');
      if (textEl) {
        if (!btn.dataset.initialText && textEl.textContent.trim() !== 'Checking out') {
          btn.dataset.initialText = textEl.textContent;
        }
        if (btn.dataset.initialText && textEl.textContent !== btn.dataset.initialText) {
          textEl.textContent = btn.dataset.initialText;
        }
      } else {
        if (!btn.dataset.initialText && btn.textContent.trim() !== 'Checking out') {
          btn.dataset.initialText = btn.textContent;
        }
        if (btn.dataset.initialText && btn.textContent.trim() === 'Checking out' && btn.textContent !== btn.dataset.initialText) {
          btn.textContent = btn.dataset.initialText;
        }
      }

      if (checkboxes.length > 0) {
        if (isAccepted) {
          btn.classList.remove('cart__checkout--disabled');
        } else {
          btn.classList.add('cart__checkout--disabled');
        }
      }
    });

    if (isAccepted) {
      document.querySelectorAll('.cart__terms-label').forEach((label) => {
        label.classList.remove('cart__checkout--errorPulse');
      });
    }
  }

  syncTermsState();

  if (window.__auTermsDelegated) return;
  window.__auTermsDelegated = true;

  const handleReturn = () => {
    /* Strip checkout loading state so the button is fully reset on back-navigation */
    document.querySelectorAll('.cart__checkout').forEach((btn) => {
      btn.classList.remove('cart__checkout--loading', 'btn--loading');
      const textEl = btn.querySelector('.cart__checkout-text');
      if (btn.dataset.initialText) {
        if (textEl) textEl.textContent = btn.dataset.initialText;
        else btn.textContent = btn.dataset.initialText;
      }
    });
    syncTermsState();
    setTimeout(syncTermsState, 50);
    setTimeout(syncTermsState, 250);
    setTimeout(syncTermsState, 600);
  };

  window.addEventListener('pageshow', handleReturn);
  window.addEventListener('popstate', handleReturn);

  document.addEventListener('drawerOpen', function () {
    syncTermsState();
  });

  document.addEventListener('change', function (e) {
    const cb = e.target && (e.target.matches?.('.cart__terms-checkbox') ? e.target : e.target.closest?.('.cart__terms-checkbox'));
    if (cb) {
      setStoredTermsState(cb.checked);
      syncTermsState();
    }
  });

  document.addEventListener('click', function (e) {
    const termsLink = e.target && e.target.closest && e.target.closest('.cart__terms-label a, .cart__terms a');
    if (termsLink) {
      const href = (termsLink.getAttribute('href') || '').trim();
      // If the link has no target destination or is '#', treat it as plain text and toggle checkbox
      if (!href || href === '#' || href === 'javascript:void(0)' || termsLink.dataset.disabled === 'true') {
        e.preventDefault();
        const activeCb = document.querySelector('#CartTermsDrawer') || document.querySelector('.cart__terms-checkbox');
        if (activeCb) {
          activeCb.checked = !activeCb.checked;
          setStoredTermsState(activeCb.checked);
          syncTermsState();
        }
        return;
      }
      // If it has a valid destination, let the link open normally without altering checkbox
      return;
    }

    const cb = e.target && e.target.closest && e.target.closest('.cart__terms-checkbox, .cart__terms-label');
    if (cb) {
      setTimeout(() => {
        const activeCb = cb.matches?.('.cart__terms-checkbox') ? cb : document.querySelector('.cart__terms-checkbox');
        if (activeCb) {
          setStoredTermsState(activeCb.checked);
        }
        syncTermsState();
      }, 10);
    }
  });

  document.addEventListener('click', function (e) {
    const btn = e.target && e.target.closest && e.target.closest('.cart__checkout');
    if (!btn) return;

    /* ── Block checkout when cart has ONLY free gifts ── */
    if (_auCartHasOnlyFreeGifts()) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      _auPulseGiftsOnlyWarning();
      return;
    }

    const checkboxes = document.querySelectorAll('.cart__terms-checkbox');
    const isTermsAccepted = getStoredTermsState();

    if (checkboxes.length > 0 && !isTermsAccepted) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      document.querySelectorAll('.cart__terms-label').forEach((label) => {
        label.classList.remove('cart__checkout--errorPulse');
        void label.offsetWidth;
        label.classList.add('cart__checkout--errorPulse');
      });

      document.querySelectorAll('.cart__checkout').forEach((b) => {
        b.classList.add('cart__checkout--disabled');
      });
      return;
    }

    btn.classList.add('cart__checkout--loading');
    const textEl = btn.querySelector('.cart__checkout-text');
    if (textEl) {
      if (!btn.dataset.initialText && textEl.textContent.trim() !== 'Checking out') {
        btn.dataset.initialText = textEl.textContent;
      }
      textEl.textContent = 'Checking out';
    } else {
      if (!btn.dataset.initialText && btn.textContent.trim() !== 'Checking out') {
        btn.dataset.initialText = btn.textContent;
      }
      btn.textContent = 'Checking out';
    }
  }, true);
}

function announcementSlider() {
  const root = document.querySelector('[data-announcement-slider]') || document.querySelector('.cart-announcement-slider');
  const slider = root?.querySelector('.cart-announcement-slider__list');
  const slides = root?.querySelectorAll('.cart-announcement-slider__item');
  const totalSlides = slides?.length ?? 0;

  if (!root || !slider || totalSlides <= 1) return;
  if (root.dataset.announcementInit === 'true') return;
  root.dataset.announcementInit = 'true';

  const slideMsRaw = getComputedStyle(root).getPropertyValue('--announcement-slide-ms').trim();
  const slideMs = Math.max(1, Math.round(parseFloat(slideMsRaw)) || 1000);
  const cActive = 'cart-announcement-slider__item--active';
  const cNoMotion = 'cart-announcement-slider__list--no-motion';
  const cDragging = 'cart-announcement-slider--dragging';

  slider.appendChild(slides[0].cloneNode(true));
  const items = slider.querySelectorAll('.cart-announcement-slider__item');
  const n = totalSlides;

  let idx = 0;
  let dragPx = 0;
  let startX = 0;
  let ptrId = null;
  let autoplayId = null;

  let wrapCtl = null;
  let slideW = 1;
  let moveRaf = 0;
  let dragAnchorIdx = 0;

  const measure = () => {
    const trackW = slider.getBoundingClientRect().width;
    const itemW = items[0]?.getBoundingClientRect().width ?? 0;
    let w = 0;
    if (itemW > 0.5 && trackW > 0.5) {
      w = Math.round(((itemW + trackW) / 2) * 1000) / 1000;
    } else if (trackW > 0.5) {
      w = trackW;
    } else if (itemW > 0.5) {
      w = itemW;
    } else {
      w = root.clientWidth || 1;
    }
    slideW = Math.max(1, w);
  };

  const applyTx = () => {
    root.style.setProperty('--announcement-tx', `${-idx * slideW + dragPx}px`);
  };

  const clampDrag = (raw) => {
    if (dragAnchorIdx >= n) return 0;
    if (dragAnchorIdx <= 0) {
      if (raw <= 0) return raw;
      const lim = slideW * 0.12;
      return lim * Math.tanh(raw / lim);
    }
    return raw;
  };

  const cancelMoveRaf = () => {
    if (moveRaf) {
      cancelAnimationFrame(moveRaf);
      moveRaf = 0;
    }
  };

  const scheduleApply = () => {
    if (moveRaf) return;
    moveRaf = requestAnimationFrame(() => {
      moveRaf = 0;
      applyTx();
    });
  };

  const setActive = (i) => {
    for (let j = 0; j < items.length; j++) {
      items[j].classList.toggle(cActive, j === i);
    }
  };

  const clearWrapReset = () => {
    if (!wrapCtl) return;
    clearTimeout(wrapCtl.tid);
    slider.removeEventListener('transitionend', wrapCtl.onEnd);
    wrapCtl = null;
  };


  const snapToRealFirstSlide = () => {
    slider.classList.add(cNoMotion);
    idx = 0;
    dragPx = 0;
    setActive(0);
    applyTx();
    void slider.offsetHeight;
    requestAnimationFrame(() => {
      slider.classList.remove(cNoMotion);
    });
  };

  const scheduleClone = () => {
    clearWrapReset();

    let finished = false;
    const finish = () => {
      if (finished) return;
      if (!wrapCtl) return;
      finished = true;
      clearTimeout(wrapCtl.tid);
      slider.removeEventListener('transitionend', wrapCtl.onEnd);
      wrapCtl = null;
      snapToRealFirstSlide();
    };

    const isTransformEnd = (e) => {
      if (e.target !== slider) return false;
      const p = e.propertyName;
      return p === 'transform' || p === '-webkit-transform';
    };

    const onEnd = (e) => {
      if (!isTransformEnd(e)) return;
      finish();
    };

    wrapCtl = {
      onEnd,
      tid: setTimeout(finish, slideMs + 450),
    };
    slider.addEventListener('transitionend', onEnd);

    requestAnimationFrame(() => {
      if (finished || !wrapCtl) return;
      const anims = typeof slider.getAnimations === 'function' ? slider.getAnimations({ subtree: false }) : [];
      const tr = anims.find(
        (a) =>
          typeof CSSTransition !== 'undefined' &&
          a instanceof CSSTransition &&
          (a.transitionProperty === 'transform' || a.transitionProperty === '-webkit-transform')
      );
      if (tr?.finished) {
        tr.finished.then(() => finish()).catch(() => { });
      }
    });
  };

  const restartAutoplay = () => {
    if (autoplayId) clearInterval(autoplayId);
    autoplayId = setInterval(goNext, 5000);
  };


  const crossfade = (prevI, incoming) => {
    queueMicrotask(() => {
      items[prevI]?.classList.remove(cActive);
      incoming?.classList.add(cActive);
    });
  };

  function goNext() {
    if (idx >= n) return;
    if (slider.classList.contains(cNoMotion)) return;
    clearWrapReset();
    const prevI = idx;
    idx++;
    measure();
    applyTx();
    crossfade(prevI, items[idx]);
    if (idx === n) scheduleClone();
  }

  function goPrev() {
    if (idx <= 0) return;
    if (slider.classList.contains(cNoMotion)) return;
    clearWrapReset();
    const prevI = idx;
    idx--;
    measure();
    applyTx();
    crossfade(prevI, items[idx]);
  }

  root.classList.add('cart-announcement-slider--initialized');
  setActive(0);
  measure();
  applyTx();

  new ResizeObserver(() => {
    if (root.classList.contains(cDragging)) return;
    measure();
    slider.classList.add(cNoMotion);
    applyTx();
    void slider.offsetHeight;
    slider.classList.remove(cNoMotion);
  }).observe(root);

  const swipeTh = () => Math.max(28, slideW * 0.16);

  const endDrag = (e) => {
    if (!root.classList.contains(cDragging)) return;
    if (ptrId !== null && e.pointerId !== ptrId) return;
    cancelMoveRaf();
    const th = swipeTh();
    const d = dragPx;
    dragPx = 0;
    const capId = ptrId;
    ptrId = null;
    root.classList.remove(cDragging);
    try {
      if (capId != null && root.hasPointerCapture(capId)) root.releasePointerCapture(capId);
    } catch (_) { }
    if (d < -th && idx < n) goNext();
    else if (d > th && idx > 0 && dragAnchorIdx > 0) goPrev();
    else applyTx();
    restartAutoplay();
  };

  const onDown = (e) => {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    if (idx >= n || ptrId !== null) return;
    ptrId = e.pointerId;
    startX = e.clientX;
    dragPx = 0;
    dragAnchorIdx = idx;
    measure();
    root.classList.add(cDragging);
    try {
      root.setPointerCapture(e.pointerId);
    } catch (_) { }
    clearWrapReset();
    if (autoplayId) {
      clearInterval(autoplayId);
      autoplayId = null;
    }
    applyTx();
  };

  const onMove = (e) => {
    if (e.pointerId !== ptrId || !root.classList.contains(cDragging)) return;
    dragPx = clampDrag(e.clientX - startX);
    scheduleApply();
  };

  root.addEventListener('pointerdown', onDown);
  root.addEventListener('pointermove', onMove, { passive: true });
  root.addEventListener('pointerup', endDrag);
  root.addEventListener('pointercancel', endDrag);
  root.addEventListener('lostpointercapture', endDrag);

  document.addEventListener('drawerOpen', () => {
    if (root.classList.contains(cDragging)) return;
    measure();
    applyTx();
  });

  restartAutoplay();
}

window.__auOpenBundleKeys = window.__auOpenBundleKeys || new Set();

function _auSnapshotOpenBundles() {
  document.querySelectorAll('.bundle-toggle.show-bundle').forEach(function(btn) {
    var vid = btn.dataset.bundleVariant;
    if (!vid) {
      var itemEl = btn.closest('[data-variant-id]');
      if (itemEl) vid = itemEl.dataset.variantId;
    }
    if (vid) window.__auOpenBundleKeys.add(String(vid));
    var bkey = btn.dataset.bundleKey;
    if (!bkey) {
      var keyEl = btn.closest('[data-key]');
      if (keyEl) bkey = keyEl.dataset.key;
    }
    if (bkey) window.__auOpenBundleKeys.add(String(bkey));
  });
}

function ensureBundleItemOrder(list) {
  if (!list || list.children.length <= 1) return;
  const items = Array.from(list.children);

  let hasSortAttr = false;
  let isSorted = true;
  let prevSort = -1;

  for (let i = 0; i < items.length; i++) {
    const s = items[i].dataset.bundleSort;
    if (s !== undefined) {
      hasSortAttr = true;
      const num = +s;
      if (num < prevSort) isSorted = false;
      prevSort = num;
    }
  }

  if (hasSortAttr) {
    if (!isSorted) {
      items.sort((a, b) => (+a.dataset.bundleSort || 99) - (+b.dataset.bundleSort || 99));
      list.append(...items);
    }
    return;
  }

  // Fallback: match by variant title / options
  const wrapper = list.closest('.cart-drawer-bundle-wrapper');
  const itemEl = list.closest('.cart__item, [data-key], [data-hulkapps-lineitem]');
  const varTitle = wrapper?.dataset?.variantTitle || itemEl?.querySelector('.cart__item--variants')?.textContent?.trim() || '';
  if (varTitle && varTitle.includes('/')) {
    const expectedFlavors = varTitle.split('/').map(s => s.trim().toLowerCase()).filter(Boolean);
    if (expectedFlavors.length > 1) {
      const assigned = new Set();
      const itemSlots = items.map((item, originalIdx) => {
        const text = (item.dataset.bundleFlavor || item.textContent || '').toLowerCase();
        let slot = -1;
        for (let s = 0; s < expectedFlavors.length; s++) {
          if (!assigned.has(s) && text.includes(expectedFlavors[s])) {
            slot = s;
            assigned.add(s);
            break;
          }
        }
        return { item, slot: slot === -1 ? 80 + originalIdx : slot };
      });

      let isSortedFallback = true;
      for (let i = 0; i < itemSlots.length - 1; i++) {
        if (itemSlots[i].slot > itemSlots[i + 1].slot) {
          isSortedFallback = false;
          break;
        }
      }
      if (!isSortedFallback) {
        itemSlots.sort((a, b) => a.slot - b.slot);
        list.append(...itemSlots.map(x => x.item));
      }
    }
  }
}

function toggleBundleDropdown(button) {
  if (!button) return;
  const list = button.nextElementSibling;
  if (!list || !list.classList.contains('bundle-items')) return;

  const isOpen = button.classList.toggle('show-bundle');
  const curItemEl = button.closest('.cart__item, [data-key], [data-hulkapps-lineitem]');
  const curKey = button.dataset.bundleKey || curItemEl?.dataset?.key;
  const curVarId = button.dataset.bundleVariant || curItemEl?.dataset?.variantId;

  if (curKey) {
    if (isOpen) window.__auOpenBundleKeys.add(String(curKey));
    else window.__auOpenBundleKeys.delete(String(curKey));
  }
  if (curVarId) {
    if (isOpen) window.__auOpenBundleKeys.add(String(curVarId));
    else window.__auOpenBundleKeys.delete(String(curVarId));
  }

  const label = button.querySelector('.bundle-toggle-text');
  const n = list.children.length;
  button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  if (label) label.textContent = isOpen ? `Hide ${n} items` : `Show ${n} items`;
}

if (!window.__auBundleDelegated) {
  window.__auBundleDelegated = true;
  document.addEventListener('click', (e) => {
    // If clicked inside the items list (e.g. image or title), do not toggle
    if (e.target.closest('.bundle-items')) return;

    const toggleBtn = e.target.closest('.bundle-toggle');
    const wrapper = e.target.closest('.cart-drawer-bundle-wrapper');
    if (!toggleBtn && !wrapper) return;

    const button = toggleBtn || wrapper.querySelector('.bundle-toggle');
    if (!button) return;

    e.preventDefault();
    toggleBundleDropdown(button);
  });
}

function bundleProductDDL(root = document) {
  const scope = (root && root.querySelectorAll) ? root : document;
  scope.querySelectorAll('.bundle-toggle').forEach((button) => {
    const list = button.nextElementSibling;
    if (!list || !list.classList.contains('bundle-items')) return;

    ensureBundleItemOrder(list);

    const itemEl = button.closest('.cart__item, [data-key], [data-hulkapps-lineitem]');
    const key = button.dataset.bundleKey || itemEl?.dataset?.key;
    const variantId = button.dataset.bundleVariant || itemEl?.dataset?.variantId;

    const isPreviouslyOpen =
      (key && window.__auOpenBundleKeys.has(String(key))) ||
      (variantId && window.__auOpenBundleKeys.has(String(variantId)));

    if (isPreviouslyOpen) {
      if (!button.classList.contains('show-bundle')) {
        const svg = button.querySelector('.bundle-toggle-svg');
        if (svg) svg.classList.add('no-transition');
        button.classList.add('show-bundle');
        if (svg) {
          requestAnimationFrame(() => {
            svg.classList.remove('no-transition');
          });
        }
      }
    }

    const label = button.querySelector('.bundle-toggle-text');
    const open = button.classList.contains('show-bundle');
    const n = list.children.length;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (label) label.textContent = open ? `Hide ${n} items` : `Show ${n} items`;
  });
}

function syncSubtotal() { }

const AU_PROC_CLASS = 'cart__checkout--processing';
const AU_CHECKOUT_SEL = '.cart__checkout';
let auProcOn = false;
let auProcTid = 0;
function setProcessingState(on) {
  if (auProcOn === on) return;
  auProcOn = on;
  if (on) {
    document.body.classList.add('au-cart-processing');
  } else {
    document.body.classList.remove('au-cart-processing');
  }
}
function beginProcessing() {
  clearTimeout(auProcTid);
  setProcessingState(true);
  auProcTid = setTimeout(() => {
    auProcTid = 0;
    setProcessingState(false);
  }, 6000);
}

function endProcessing() {
  if (!auProcOn) return;

  if (auFgBusy) return;
  clearTimeout(auProcTid);
  auProcTid = setTimeout(() => {
    auProcTid = 0;
    setProcessingState(false);
  }, 20);
}

function _auMoneyToCents(text, el) {
  if (el) {
    const rawAttr = el.dataset
      ? (el.dataset.price || el.dataset.cents)
      : (el.getAttribute && (el.getAttribute('data-price') || el.getAttribute('data-cents')));
    if (rawAttr !== null && rawAttr !== undefined && rawAttr !== '') {
      const p = parseInt(rawAttr, 10);
      if (Number.isFinite(p) && p >= 0) return p;
    }
  }

  if (text === null || text === undefined) return null;
  if (typeof text === 'number') {
    return Number.isFinite(text) ? Math.round(text) : null;
  }

  const str = String(text).replace(/[^0-9.,-]/g, '').trim();
  if (!str) return null;

  const hasComma = str.includes(',');
  const hasDot = str.includes('.');

  let normalized = str;

  if (hasComma && hasDot) {
    const lastComma = str.lastIndexOf(',');
    const lastDot = str.lastIndexOf('.');
    if (lastComma > lastDot) {
      // European format: 1.234,56 or 3.499,00 (dot is thousands, comma is decimal)
      normalized = str.split('.').join('').replace(',', '.');
    } else {
      // US/UK format: 1,234.56 or 3,499.00 (comma is thousands, dot is decimal)
      normalized = str.split(',').join('');
    }
  } else if (hasComma) {
    // Only comma present: e.g. '34,99' (Euro decimal) or '1,234'
    const parts = str.split(',');
    if (parts.length === 2 && parts[1].length <= 2) {
      normalized = parts[0] + '.' + parts[1];
    } else {
      normalized = str.split(',').join('');
    }
  } else if (hasDot) {
    // Only dot present: e.g. '34.99'
  }

  const n = parseFloat(normalized);
  return Number.isFinite(n) ? Math.round(n * 100) : null;
}

(function () {
  const FORM_SEL =
    '#CartDrawerForm, #CartPageForm, form[data-location="drawer"], form[data-location="page"], form[data-location="cart"]';
  const pending = new Set();
  let raf = 0;

  const moneyToCents = _auMoneyToCents;


  function updateMotivationalBar(form, cents) {
    const bar = form.querySelector('#motivational-bar-wrapper');
    if (!bar) return;

    const t1 = parseFloat(bar.dataset.t1 || '0') * 100;
    const t2 = parseFloat(bar.dataset.t2 || '0') * 100;
    const t3 = parseFloat(bar.dataset.t3 || '0') * 100;
    const t4 = parseFloat(bar.dataset.t4 || '0') * 100;

    const enabledTiers = [];
    if (t1 > 0) enabledTiers.push(t1);
    if (t2 > 0) enabledTiers.push(t2);
    if (t3 > 0) enabledTiers.push(t3);
    if (t4 > 0) enabledTiers.push(t4);

    const tierCount = enabledTiers.length;
    let barFillPct = 0;

    if (tierCount > 0) {
      const segPct = 100.0 / tierCount;
      const halfSeg = segPct / 2.0;
      let prevTierCents = 0;
      let prevTierVisual = 0;
      let fillDone = false;
      let slot = 0;

      for (let i = 0; i < tierCount; i++) {
        const tCents = enabledTiers[i];
        if (fillDone === false) {
          slot += 1;
          const tierVisual = segPct * slot - halfSeg;
          if (cents >= tCents) {
            prevTierCents = tCents;
            prevTierVisual = tierVisual;
          } else {
            const segCents = tCents - prevTierCents;
            const spent = cents - prevTierCents;
            const segRatio = Math.min(spent / segCents, 1.0);
            const segVisual = tierVisual - prevTierVisual;
            barFillPct = segRatio * segVisual + prevTierVisual;
            fillDone = true;
          }
        }
      }
      if (fillDone === false) {
        barFillPct = 100;
      }
    }

    const fillEl = bar.querySelector('.motivational-bar__fill');
    if (fillEl) {
      const target = `${Math.min(barFillPct, 100)}%`;
      const from = _lastFillPct !== null ? _lastFillPct : '0%';
      fillEl.style.transition = 'none';
      fillEl.style.width = from;
      void fillEl.offsetWidth;
      fillEl.style.transition = '';
      fillEl.style.width = target;
      _lastFillPct = target;
    }

    let currentSum = 0;
    let lastConditionMet = true;
    const blocks = bar.querySelectorAll('.motivational-bar__block');

    blocks.forEach((block, idx) => {
      if (idx >= tierCount) return;
      const tCents = enabledTiers[idx];
      let progress = 0;
      const prevCents = idx === 0 ? 0 : enabledTiers[idx - 1];

      if (idx === 0 || lastConditionMet) {
        const offsetPrice = cents - prevCents;
        const offsetMinimum = tCents - prevCents;
        progress = Math.min(Math.max(offsetPrice / offsetMinimum, 0), 1) * 100;
      }

      const badge = block.querySelector('.motivational-bar__block-badge');
      if (badge) {
        if (progress >= 100) {
          badge.classList.add('motivational-bar__block-badge--active');
          lastConditionMet = true;
          currentSum = tCents;
        } else {
          badge.classList.remove('motivational-bar__block-badge--active');
          lastConditionMet = false;
        }
      }
    });

    let unlockedText = '';
    let neededText = '';
    let neededAmountInCents = 0;
    let nextTierProduct = '';

    lastConditionMet = true;
    for (let idx = 0; idx < tierCount; idx++) {
      const tCents = enabledTiers[idx];
      const tNum = idx + 1;
      const tUnlocked = bar.getAttribute(`data-t${tNum}-unlocked`) || '';
      const tNeeded = bar.getAttribute(`data-t${tNum}-needed`) || '';
      const tProduct = bar.getAttribute(`data-t${tNum}-product`) || '';

      let progress = 0;
      const prevCents = idx === 0 ? 0 : enabledTiers[idx - 1];
      if (idx === 0 || lastConditionMet) {
        const offsetPrice = cents - prevCents;
        const offsetMinimum = tCents - prevCents;
        progress = Math.min(Math.max(offsetPrice / offsetMinimum, 0), 1) * 100;
      }

      if (progress >= 100) {
        lastConditionMet = true;
        unlockedText = tUnlocked;
      } else {
        if (lastConditionMet) {
          neededText = tNeeded;
          neededAmountInCents = tCents - cents;
          nextTierProduct = tProduct;
        }
        lastConditionMet = false;
      }
    }

    const textEl = bar.querySelector('.motivational-bar__text');
    if (textEl) {
      let finalHtml = unlockedText;
      if (neededText) {
        const moneyFmt =
          (window.theme && window.theme.settings && window.theme.settings.moneyFormat) ||
          (document.querySelector('[data-money-format]') &&
            document.querySelector('[data-money-format]').dataset &&
            document.querySelector('[data-money-format]').dataset.moneyFormat) ||
          '${{amount}}';
        const formatted = window.theme.Currency
          ? window.theme.Currency.formatMoney(neededAmountInCents, moneyFmt)
          : `${(neededAmountInCents / 100).toFixed(2)}`;
        const neededAmountSpan = `<span>${formatted.replace(/\s/g, '')}</span>`;
        let textWithAmount = neededText.replace('XY', neededAmountSpan);
        const showProduct = bar.dataset.giftInProgress === 'true';
        if (showProduct && nextTierProduct) {
          textWithAmount += ' ' + nextTierProduct;
        }
        finalHtml += (finalHtml ? ' ' : '') + textWithAmount;
      }
      textEl.innerHTML = finalHtml;
    }
  }

  function recompute(form, isFinal) {
    const products = form.querySelector('[data-products]');
    if (!products) return;
    const fmt = window.theme && window.theme.Currency && window.theme.Currency.formatMoney;
    if (typeof fmt !== 'function') return;
    const moneyFmt = window.theme.settings && window.theme.settings.moneyFormat;


    let cents = 0;
    let origCents = 0;
    let lineItemsCounted = 0;
    products.querySelectorAll('[data-hulkapps-lineitem]').forEach((line) => {
      const isGift = line.classList.contains('cart__item--au-free-gift');
      const qi = line.querySelector('input[name="updates[]"]');
      const qty = qi ? parseInt(qi.value || '0', 10) : 1;
      if (!Number.isFinite(qty) || qty < 1) return;

      let priceSpan = null;
      line.querySelectorAll('[data-hulkapps-ci-price], [data-au-ci-price]').forEach((s) => {
        if (priceSpan || s.closest('.cart__price--strikethrough')) return;
        priceSpan = s;
      });
      if (!priceSpan) return;
      const unit = moneyToCents(priceSpan.textContent, priceSpan);
      if (unit === null) return;
      cents += unit * qty;
      lineItemsCounted++;

      {
        let origUnit = unit;
        const strikeSpan = line.querySelector(
          '.cart__price--strikethrough [data-hulkapps-ci-price], .cart__price--strikethrough [data-au-ci-price]',
        );
        if (strikeSpan) {
          const strikeVal = moneyToCents(strikeSpan.textContent, strikeSpan);
          if (strikeVal !== null && strikeVal > origUnit) origUnit = strikeVal;
        }
        origCents += origUnit * qty;
      }
    });

    updateMotivationalBar(form, cents);

    if (lineItemsCounted > 0) {
      const box =
        form.querySelector('[data-hulkapps-cart-total]') ||
        form.querySelector('[data-subtotal]');
      if (box) {
        let target = box.querySelector('.bcpo-cart-original-total');
        if (!target) {

          box.innerHTML = '';
          target = document.createElement('span');
          target.className = 'bcpo-cart-original-total';
          box.appendChild(target);
        }
        const formatted = fmt.call(window.theme.Currency, cents, moneyFmt);
        if (target.textContent !== formatted) target.textContent = formatted;
      }
    }


    const origEl = form.querySelector('[data-subtotal-original]');
    if (origEl) {
      if (origCents > 0 && origCents > cents) {
        const preFormatted = fmt.call(window.theme.Currency, origCents, moneyFmt);
        if (origEl.innerHTML !== preFormatted) origEl.innerHTML = preFormatted;
        if (origEl.classList.contains('hide')) origEl.classList.remove('hide');
        if (origEl.getAttribute('aria-hidden') !== 'false') {
          origEl.setAttribute('aria-hidden', 'false');
        }
      } else if (isFinal && lineItemsCounted > 0) {
        if (origEl.innerHTML !== '') origEl.innerHTML = '';
        if (!origEl.classList.contains('hide')) origEl.classList.add('hide');
        if (origEl.getAttribute('aria-hidden') !== 'true') {
          origEl.setAttribute('aria-hidden', 'true');
        }
      }
    }
  }


  function schedule(form) {
    pending.add(form);
    if (!raf) {
      raf = requestAnimationFrame(() => {
        raf = 0;
        pending.forEach((f) => recompute(f, true));
        pending.clear();
      });
    }
  }

  function wire() {
    document.querySelectorAll(FORM_SEL).forEach((form) => {
      const products = form.querySelector('[data-products]');
      if (!products) return;

      if (form.__auSubProducts !== products) {
        form.__auSubProducts = products;
        new MutationObserver(() => schedule(form)).observe(products, {
          childList: true,
          subtree: true,
          characterData: true,
        });

        form.addEventListener('change', (e) => {
          if (e.target.matches?.('.js-qty__num')) {
            schedule(form);
          }
        });
        form.addEventListener('input', (e) => {
          if (e.target.matches?.('.js-qty__num')) {
            schedule(form);
          }
        });
        form.addEventListener('click', (e) => {
          const btn = e.target.closest?.('.js-qty__adjust, .js-qty__adjust--remove');
          if (btn) {
            requestAnimationFrame(() => schedule(form));
          }
        });
      }
      schedule(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }

  document.addEventListener('cart:updated', wire);
})();

let _auMarkupAbort = null;
function _auAbortMarkup() {
  if (!_auMarkupAbort) return;
  try { _auMarkupAbort.abort(); } catch (_) { }
  _auMarkupAbort = null;
}
(function patchCartMarkup() {
  const t = window.theme;
  if (!t || !t.cart || typeof t.cart.getCartProductMarkup !== 'function' || !t.routes) {
    setTimeout(patchCartMarkup, 50);
    return;
  }
  if (t.cart.__auPatched) return;
  t.cart.__auPatched = true;

  t.cart.getCartProductMarkup = function () {

    _auAbortMarkup();
    const aborter = new AbortController();
    _auMarkupAbort = aborter;

    let url = '' + t.routes.cartPage + '?t=' + Date.now();
    url += url.indexOf('?') === -1 ? '?view=ajax' : '&view=ajax';

    return fetch(url, {
      credentials: 'same-origin',
      method: 'GET',
      signal: aborter.signal,
    })
      .then((r) => {
        if (aborter.signal.aborted) {



          return new Promise(() => { });
        }
        return r.text();
      })
      .catch((err) => {
        if (err && err.name === 'AbortError') {

          return new Promise(() => { });
        }
        throw err;
      })
      .finally(() => {

        if (_auMarkupAbort === aborter) _auMarkupAbort = null;
      });
  };
})();

(function patchCartMarkupStrikethrough() {
  const proto = window.theme && window.theme.CartForm && window.theme.CartForm.prototype;
  if (!proto || typeof proto.cartMarkup !== 'function') {
    setTimeout(patchCartMarkupStrikethrough, 50);
    return;
  }
  if (proto.__auStrikePatched) return;
  proto.__auStrikePatched = true;

  if (proto._parseProductHTML && !proto._auParsePatched) {
    proto._auParsePatched = true;
    const _origParse = proto._parseProductHTML;
    proto._parseProductHTML = function(html) {
      const res = _origParse.apply(this, arguments);
      if (res && res.items) {
        try { bundleProductDDL(res.items); } catch (_) {}
      }
      return res;
    };
  }

  const orig = proto.cartMarkup;
  proto.cartMarkup = function (html) {
    const result = orig.apply(this, arguments);

    const form = this.form;
    const origEl = form && form.querySelector('[data-subtotal-original]');
    if (!origEl) return result;

    const itemsBox = form.querySelector('.cart__items');
    if (!itemsBox) return result;

    const products = form.querySelector('[data-products]');
    let domOK = false;
    let cents = 0;
    let origCents = 0;
    if (products) {
      products.querySelectorAll('[data-hulkapps-lineitem]').forEach((line) => {
        const isGift = line.classList.contains('cart__item--au-free-gift');
        const qi = line.querySelector('input[name="updates[]"]');
        const qty = qi ? parseInt(qi.value || '0', 10) : 1;
        if (!Number.isFinite(qty) || qty < 1) return;

        let priceSpan = null;
        line.querySelectorAll('[data-hulkapps-ci-price], [data-au-ci-price]').forEach((s) => {
          if (priceSpan || s.closest('.cart__price--strikethrough')) return;
          priceSpan = s;
        });
        if (!priceSpan) return;
        const unit = _auMoneyToCents(priceSpan.textContent, priceSpan);
        if (unit === null) return;
        cents += unit * qty;
        domOK = true;

        {
          let origUnit = unit;
          const strikeSpan = line.querySelector(
            '.cart__price--strikethrough [data-hulkapps-ci-price], .cart__price--strikethrough [data-au-ci-price]',
          );
          if (strikeSpan) {
            const strikeVal = _auMoneyToCents(strikeSpan.textContent, strikeSpan);
            if (strikeVal !== null && strikeVal > origUnit) origUnit = strikeVal;
          }
          origCents += origUnit * qty;
        }
      });
    }

    if (domOK) {
      if (origCents > 0 && origCents > cents) {
        origEl.innerHTML = theme.Currency.formatMoney(origCents, theme.settings.moneyFormat);
        origEl.classList.remove('hide');
        origEl.setAttribute('aria-hidden', 'false');
      } else {
        origEl.innerHTML = '';
        origEl.classList.add('hide');
        origEl.setAttribute('aria-hidden', 'true');
      }
    } else {
      const pre = parseInt(itemsBox.getAttribute('data-cart-original-subtotal') || '', 10);
      const paid = parseInt(itemsBox.getAttribute('data-cart-paid-subtotal') || '', 10);
      if (Number.isFinite(pre) && pre > 0 && Number.isFinite(paid) && paid > 0 && pre > paid) {
        origEl.innerHTML = theme.Currency.formatMoney(pre, theme.settings.moneyFormat);
        origEl.classList.remove('hide');
        origEl.setAttribute('aria-hidden', 'false');
      } else {
        origEl.innerHTML = '';
        origEl.classList.add('hide');
        origEl.setAttribute('aria-hidden', 'true');
      }
    }

    return result;
  };
})();

function getActiveCartItemsContainer() {
  let box = document.querySelector('#CartPageForm .cart__items');
  if (!box) {
    box = document.querySelector('#CartDrawerForm .cart__items') || document.querySelector('.cart__items');
  }
  return box;
}

async function autoFreeGiftsFresh() {
  try {
    const res = await fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!res.ok) { return autoFreeGifts(); }
    const cart = await res.json();
    return autoFreeGifts(cart);
  } catch (_) {
    return autoFreeGifts();
  }
}

let auFgBusy = false;
let _auFgPending = false;
async function autoFreeGifts(providedCart) {

  if (auFgBusy) { _auFgPending = true; return; }
  auFgBusy = true;
  let didWork = false;
  try {
    const node = document.querySelector('[data-au-free-gift-tiers]');
    if (!node) return;
    let tiers;
    try { tiers = JSON.parse((node.textContent || '[]').trim() || '[]'); } catch { return; }
    if (!Array.isArray(tiers) || !tiers.length) return;

    const isGift = (it) => {
      const p = it.properties || {};
      return p._auTierGift === '1' || p._auTierGift === true || p._isFreeGift === 'true' || p._isFreeGift === true;
    };

    let paid;
    let giftLines;
    let themeGiftVids;
    const box = getActiveCartItemsContainer();

    let isDomPath = false;
    let _domItemsFound = 0;
    if (box) {
      paid = 0;
      giftLines = [];
      themeGiftVids = new Set();
      box.querySelectorAll('[data-hulkapps-lineitem]').forEach((line) => {
        const vid = Number(line.dataset.variantId || '');
        const key = line.dataset.key || '';
        const isGift = line.classList.contains('cart__item--au-free-gift');
        if (isGift && key) giftLines.push({ vid, key });
        if (line.dataset.auTierGift === 'true' && vid) themeGiftVids.add(vid);
        if (isGift) return;

        let priceSpan = null;
        line.querySelectorAll('[data-hulkapps-ci-price], [data-au-ci-price]').forEach((s) => {
          if (priceSpan || s.closest('.cart__price--strikethrough')) return;
          priceSpan = s;
        });
        if (!priceSpan) return;
        const unit = _auMoneyToCents(priceSpan.textContent, priceSpan);
        if (unit === null) return;

        const qi = line.querySelector('input[name="updates[]"]');
        const qty = qi ? parseInt(qi.value || '0', 10) : 1;
        paid += unit * (Number.isFinite(qty) && qty > 0 ? qty : 1);
        _domItemsFound++;
      });
      if (!_domItemsFound) {
        paid = undefined;
      } else {
        isDomPath = true;
        const rawSubtotal = box.dataset.cartSubtotal || box.getAttribute('data-cart-subtotal');
        if (rawSubtotal !== null && rawSubtotal !== undefined && rawSubtotal !== '') {
          const subtotalAttr = Number(rawSubtotal);
          if (Number.isFinite(subtotalAttr) && subtotalAttr >= 0) {
            paid = Math.min(paid, subtotalAttr);
          }
        }
        const rawPaidSubtotal = box.dataset.cartPaidSubtotal || box.getAttribute('data-cart-paid-subtotal');
        if (rawPaidSubtotal !== null && rawPaidSubtotal !== undefined && rawPaidSubtotal !== '') {
          const paidSubtotalAttr = Number(rawPaidSubtotal);
          if (Number.isFinite(paidSubtotalAttr) && paidSubtotalAttr >= 0) {
            paid = Math.min(paid, paidSubtotalAttr);
          }
        }
      }
    }

    if (!Number.isFinite(paid) && providedCart && Array.isArray(providedCart.items)) {
      paid = Number(providedCart.total_price) || 0;
      giftLines = [];
      themeGiftVids = new Set();
      for (const it of providedCart.items) {
        const v = Number(it.variant_id);
        if (isGift(it)) {
          giftLines.push({ vid: v, key: it.key });
          if (v) themeGiftVids.add(v);
        }
      }
    }

    if (!Number.isFinite(paid)) {
      let cart;
      try { cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()); }
      catch { return; }
      if (!cart || !Array.isArray(cart.items)) return;
      paid = Number(cart.total_price) || 0;
      giftLines = [];
      themeGiftVids = new Set();
      for (const it of cart.items) {
        const v = Number(it.variant_id);
        if (isGift(it)) {
          giftLines.push({ vid: v, key: it.key });
          if (v) themeGiftVids.add(v);
        }
      }
    }
    if (!Number.isFinite(paid)) return;

    var _giftSig = '';
    if (giftLines) {
      for (var _gi = 0; _gi < giftLines.length; _gi++) {
        _giftSig += giftLines[_gi].vid + ':' + giftLines[_gi].key + '|';
      }
    }
    if (window._auLastGiftPaid === paid && window._auLastGiftSig === _giftSig) {
      return;
    }
    window._auLastGiftPaid = paid;
    window._auLastGiftSig = _giftSig;

    const wanted = new Set();
    const toAdd = [];
    for (const t of tiers) {
      const vid = Number(t?.variant_id);
      const min = Number(t?.min);
      if (!vid || !Number.isFinite(min) || paid < min) continue;
      if (t && t.available === false) continue;
      if (wanted.has(vid)) continue;
      wanted.add(vid);
      if (!themeGiftVids.has(vid)) {
        toAdd.push({
          id: vid,
          quantity: 1,
          properties: { _isFreeGift: 'true', _auTierGift: '1' },
        });
      }
    }

    const toRemoveKeys = [];
    const keptGiftVid = new Set();
    for (const { vid, key } of giftLines) {
      if (!key) continue;
      if (!wanted.has(vid)) toRemoveKeys.push(key);
      else if (keptGiftVid.has(vid)) toRemoveKeys.push(key);
      else keptGiftVid.add(vid);
    }

    if (!toAdd.length && !toRemoveKeys.length) return;

    didWork = true;
    beginProcessing();

    _auAbortMarkup();
    const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

    if (toRemoveKeys.length) {
      const updates = {};
      for (const key of toRemoveKeys) {
        updates[key] = 0;
      }
      window.__AU_IS_BACKGROUND_CART_OP__ = true;
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers,
          body: JSON.stringify({ updates }),
        });
        if (!res.ok && window.console) {
          console.warn('[au-cart] Free gift removal skipped:', await res.text());
        }
      } catch (err) {
        if (window.console) console.warn('[au-cart] Free gift remove error:', err);
      } finally {
        window.__AU_IS_BACKGROUND_CART_OP__ = false;
      }
    }

    if (toAdd.length) {
      window.__AU_IS_BACKGROUND_CART_OP__ = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers,
          body: JSON.stringify({ items: toAdd }),
        });
        if (!res.ok && window.console) {
          console.warn('[au-cart] Free gift add skipped:', await res.text());
        }
      } catch (err) {
        if (window.console) console.warn('[au-cart] Free gift add error:', err);
      } finally {
        window.__AU_IS_BACKGROUND_CART_OP__ = false;
      }
    }
  } finally {
    auFgBusy = false;
    if (!didWork) {
      document.body.classList.add('au-gifts-validated');
    }
    if (didWork) {
      _auSnapshotOpenBundles();
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
    if (_auFgPending) {
      _auFgPending = false;
      autoFreeGifts();
    }
  }
}

let _lastFillPct = null;

let _auSafetyTid = 0;
function _auClearActionLock() {
  setProcessingState(false);

  document.querySelectorAll('.js-qty__wrapper.is-loading').forEach((el) => {
    el.classList.remove('is-loading');
  });
  document.querySelectorAll('.js-qty__selectors.is-locked, .js-qty__wrapper.is-locked').forEach((el) => {
    el.classList.remove('is-locked');
  });
  document.querySelectorAll('.js-qty__adjust.is-acting, .js-qty__adjust--remove.is-removing').forEach((el) => {
    el.classList.remove('is-acting');
    el.classList.remove('is-removing');
    el.removeAttribute('aria-busy');
  });

  document.querySelectorAll('.js-qty__adjust[disabled], .js-qty__adjust--remove[disabled]').forEach((el) => {
    el.disabled = false;
  });
}
function _auScheduleSafety() {
  clearTimeout(_auSafetyTid);
  _auSafetyTid = setTimeout(() => {
    _auSafetyTid = 0;
    _auClearActionLock();
  }, 4000);
}
function _auCancelSafety() {
  if (!_auSafetyTid) return;
  clearTimeout(_auSafetyTid);
  _auSafetyTid = 0;
}

function wireCart() {
  if (window.__auCartWired) return;
  window.__auCartWired = true;
  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('.js-qty__adjust, .js-qty__adjust--remove');
    if (!btn || (!btn.closest('[data-products]') && !btn.closest('.cart__item') && !btn.closest('#CartDrawer'))) return;
    beginProcessing();
    if (btn.classList.contains('js-qty__adjust--remove')) {
      btn.classList.add('is-removing');
      btn.setAttribute('aria-busy', 'true');
      const item = btn.closest('.cart__item');
      if (item) {
        const input = item.querySelector('.js-qty__num');
        if (input) {
          input.value = 0;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    } else if (btn.matches('.js-qty__adjust--plus, .js-qty__adjust--minus')) {
      const wrapper = btn.closest('.js-qty__selectors') || btn.closest('.js-qty__wrapper');
      if (wrapper) {
        wrapper.classList.add('is-locked');
        const plusBtn = wrapper.querySelector('.js-qty__adjust--plus');
        const minusBtn = wrapper.querySelector('.js-qty__adjust--minus');
        if (plusBtn) plusBtn.disabled = true;
        if (minusBtn) minusBtn.disabled = true;
      }
      btn.classList.add('is-acting');
      btn.setAttribute('aria-busy', 'true');
      const item = btn.closest('.cart__item');
      if (item) {
        const removeBtn = item.querySelector('.js-qty__adjust--remove');
        if (removeBtn) removeBtn.disabled = true;
      }
    }
    _auScheduleSafety();
  }, true);
  document.addEventListener('change', (e) => {
    if (e.target.matches?.('.js-qty__num') && e.target.closest('[data-products]')) {
      beginProcessing();
      _auScheduleSafety();
    }
  });


  document.addEventListener('ajaxProduct:added', () => {
    beginProcessing();
  });

  let raf = 0;
  let lastSig = '';
  const cartSig = () => {
    const box = getActiveCartItemsContainer();
    if (!box) return '';
    return [
      box.dataset.count || '',
      box.dataset.cartSubtotal || '',
      box.dataset.cartOriginalSubtotal || '',
      box.dataset.cartPaidSubtotal || '',
    ].join('|');
  };
  const fire = () => {
    /* Restore bundle dropdown state synchronously (before browser paint)
       so the user never sees the dropdown flash closed during rebuilds */
    try { bundleProductDDL(); } catch (_) {}

    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      const sig = cartSig();
      if (sig && sig === lastSig) { endProcessing(); return; }
      if (sig) lastSig = sig;

      _auCancelSafety();
      bundleProductDDL();
      syncSubtotal();
      autoFreeGifts();
      _auSyncGiftsOnlyState();
      endProcessing();
    });
  };
  document.querySelectorAll('[data-products]').forEach((el) => {
    new MutationObserver(fire).observe(el, { childList: true });
  });
}

/* ── Free-gifts-only checkout guard ─────────────────────────────── */
function _auCartHasOnlyFreeGifts() {
  var box = getActiveCartItemsContainer();
  if (!box) return false;
  var lines = box.querySelectorAll('[data-hulkapps-lineitem]');
  if (!lines.length) return false;
  var hasPaid = false;
  for (var i = 0; i < lines.length; i++) {
    if (!lines[i].classList.contains('cart__item--au-free-gift')) {
      hasPaid = true;
      break;
    }
  }
  return !hasPaid;
}

function _auPulseGiftsOnlyWarning() {
  document.querySelectorAll('.au-gifts-only-warning').forEach(function (el) {
    el.classList.remove('au-gifts-only-warning--pulse');
    void el.offsetWidth;
    el.classList.add('au-gifts-only-warning--pulse');
  });
}

function _auSyncGiftsOnlyState() {
  var onlyGifts = _auCartHasOnlyFreeGifts();

  /* Toggle disabled class on checkout buttons */
  document.querySelectorAll('.cart__checkout').forEach(function (btn) {
    if (onlyGifts) {
      btn.classList.add('cart__checkout--gifts-only');
    } else {
      btn.classList.remove('cart__checkout--gifts-only');
    }
  });

  /* Show / hide the warning message */
  document.querySelectorAll('.cart__checkout-wrapper').forEach(function (wrapper) {
    var warn = wrapper.querySelector('.au-gifts-only-warning');
    if (onlyGifts) {
      if (!warn) {
        warn = document.createElement('div');
        warn.className = 'au-gifts-only-warning';
        warn.textContent = 'Please add a product to checkout with your free gift.';
        wrapper.insertBefore(warn, wrapper.firstChild);
      }
      warn.style.display = '';
    } else if (warn) {
      warn.style.display = 'none';
    }
  });
}
/* ── end guard ─────────────────────────────────────────────────── */

function main() {
  cartTermsLabelPulse();
  announcementSlider();
  bundleProductDDL();
  syncSubtotal();
  wireCart();
  autoFreeGifts();
  _auSyncGiftsOnlyState();
}

(function() {
  if (window.__auCartOptimized) return;
  window.__auCartOptimized = true;

  if (window.theme && window.theme.CartForm) {
    const _origInit = theme.CartForm.prototype.init;
    theme.CartForm.prototype.init = function() {
      if (this.form) {
        this.form.cartFormInstance = this;
      }
      return _origInit.apply(this, arguments);
    };

    if (theme.CartForm.prototype._parseProductHTML && !theme.CartForm.prototype._auParsePatched) {
      theme.CartForm.prototype._auParsePatched = true;
      const _origParse = theme.CartForm.prototype._parseProductHTML;
      theme.CartForm.prototype._parseProductHTML = function(html) {
        const res = _origParse.apply(this, arguments);
        if (res && res.items) {
          try { bundleProductDDL(res.items); } catch (_) {}
        }
        return res;
      };
    }
  }

  var _origOpen = theme.Drawers.prototype.open;
  theme.Drawers.prototype.open = function(evt, returnFocusEl) {
    document.documentElement.classList.remove(this.config.closingClass);
    return _origOpen.call(this, evt, returnFocusEl);
  };

  var _origOff = theme.delegate.off;
  theme.delegate.off = function(event) {
    if (!this.namespaces) return this;
    var baseEvent = event.split('.')[0];
    var toRemove = [];
    for (var key in this.namespaces) {
      if (this.namespaces.hasOwnProperty(key) && key === event) {
        toRemove.push(this.namespaces[key]);
        delete this.namespaces[key];
      }
    }
    for (var i = 0; i < toRemove.length; i++) {
      this.removeEventListener(baseEvent, toRemove[i]);
    }
    return this;
  };

  var _origCartMarkup = theme.CartForm.prototype.cartMarkup;
  const FORM_SEL = '#CartDrawerForm, #CartPageForm, form[data-location="drawer"], form[data-location="page"], form[data-location="cart"]';

  theme.CartForm.prototype.buildCart = function() {
    var _this = this;

    /* Snapshot open bundle state + scroll position before DOM destruction */
    _auSnapshotOpenBundles();
    var scrollable = (_this.form && _this.form.querySelector('.drawer__scrollable'))
      || document.querySelector('#CartDrawer .drawer__scrollable');
    var savedScroll = scrollable ? scrollable.scrollTop : 0;

    theme.cart.getCartProductMarkup()
      .then((text) => {



        try { _this.cartMarkup(text); } catch (_) {}


        document.querySelectorAll(FORM_SEL).forEach(function(form) {
          if (form !== _this.form && form.cartFormInstance) {
            form.cartFormInstance.cartMarkup(text);
          }
        });
        _auClearActionLock();

        /* Restore scroll position after DOM rebuild */
        if (scrollable && savedScroll > 0) {
          scrollable.scrollTop = savedScroll;
        }
      })
      .catch((err) => {
        _auClearActionLock();
        if (window.console) console.warn('[au-cart] Rebuild failed:', err);
      });
  };

  theme.CartForm.prototype.cartMarkup = function(text) {
    _origCartMarkup.call(this, text);
    _auClearActionLock();
    try { bundleProductDDL(this.form || document); } catch (_) {}
    try { cartTermsLabelPulse(); } catch (_) {}
  };

  document.addEventListener('ajaxProduct:added', function() {
    var cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer && cartDrawer.classList.contains('drawer--is-open')) {
      document.documentElement.classList.add('js-drawer-open');
      document.documentElement.classList.remove('js-drawer-closing');
    }
  });
})();
(function patchChangeItem() {
  const t = window.theme;
  if (!t || !t.cart || typeof t.cart.changeItem !== 'function') {
    setTimeout(patchChangeItem, 50);
    return;
  }
  if (t.cart.__auChangeItemPatched) return;
  t.cart.__auChangeItemPatched = true;

  function calculateCartUpdates(targetKey, targetQty) {
    const node = document.querySelector('[data-au-free-gift-tiers]');
    if (!node) return { updates: { [targetKey]: targetQty }, toAdd: [] };
    let tiers;
    try {
      tiers = JSON.parse((node.textContent || '[]').trim() || '[]');
    } catch {
      return { updates: { [targetKey]: targetQty }, toAdd: [] };
    }
    if (!Array.isArray(tiers) || !tiers.length) {
      return { updates: { [targetKey]: targetQty }, toAdd: [] };
    }

    const box = getActiveCartItemsContainer();
    if (!box) return { updates: { [targetKey]: targetQty }, toAdd: [] };

    let projectedPaid = 0;
    const currentGifts = [];
    const currentGiftVids = new Set();

    box.querySelectorAll('[data-hulkapps-lineitem]').forEach((line) => {
      const vid = Number(line.dataset.variantId || '');
      const key = line.dataset.key || '';
      const isGift = line.classList.contains('cart__item--au-free-gift');
      
      let priceSpan = null;
      line.querySelectorAll('[data-hulkapps-ci-price], [data-au-ci-price]').forEach((s) => {
        if (priceSpan || s.closest('.cart__price--strikethrough')) return;
        priceSpan = s;
      });
      if (!priceSpan) return;
      const unit = _auMoneyToCents(priceSpan.textContent, priceSpan);
      if (unit === null) return;

      if (isGift) {
        if (key) currentGifts.push({ vid, key });
        if (vid) currentGiftVids.add(vid);
        return;
      }

      const qi = line.querySelector('input[name="updates[]"]');
      let qty = qi ? parseInt(qi.value || '0', 10) : 1;
      if (!Number.isFinite(qty) || qty < 0) qty = 1;

      if (key === targetKey) {
        qty = targetQty;
      }

      projectedPaid += unit * qty;
    });

    const wanted = new Set();
    const toAdd = [];
    for (const t of tiers) {
      const vid = Number(t?.variant_id);
      const min = Number(t?.min);
      if (!vid || !Number.isFinite(min) || projectedPaid < min) continue;
      if (t && t.available === false) continue;
      if (wanted.has(vid)) continue;
      wanted.add(vid);
      if (!currentGiftVids.has(vid)) {
        toAdd.push({
          id: vid,
          quantity: 1,
          properties: { _isFreeGift: 'true', _auTierGift: '1' },
        });
      }
    }

    const updates = { [targetKey]: targetQty };
    const keptGiftVid = new Set();
    for (const { vid, key } of currentGifts) {
      if (!key) continue;
      if (!wanted.has(vid)) {
        updates[key] = 0;
      } else if (keptGiftVid.has(vid)) {
        updates[key] = 0;
      } else {
        keptGiftVid.add(vid);
      }
    }

    return { updates, toAdd };
  }

  t.cart.changeItem = function(key, qty) {
    const { updates, toAdd } = calculateCartUpdates(key, qty);

    return t.cart._updateCart({
      url: (theme.routes.cartUpdate || '/cart/update.js') + '?t=' + Date.now(),
      data: JSON.stringify({ updates })
    }).then(async function(cart) {
      let parsedCart = cart;
      if (typeof cart === 'string') {
        try {
          parsedCart = JSON.parse(cart);
        } catch (_) {}
      }

      if (toAdd.length && parsedCart && Array.isArray(parsedCart.items)) {
        try {
          const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: toAdd })
          });
          if (addRes.ok) {
            parsedCart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
          }
        } catch (err) {
          if (window.console) console.warn('[au-cart] Free gift add error:', err);
        }
      }

      if (parsedCart && Array.isArray(parsedCart.items)) {
        const isGift = (it) => {
          const p = it.properties || {};
          return p._auTierGift === '1' || p._auTierGift === true || p._isFreeGift === 'true' || p._isFreeGift === true;
        };
        let giftSig = '';
        let paid = Number(parsedCart.total_price) || 0;
        for (const it of parsedCart.items) {
          if (isGift(it)) {
            giftSig += it.variant_id + ':' + it.key + '|';
          }
        }
        window._auLastGiftPaid = paid;
        window._auLastGiftSig = giftSig;
      }

      if (parsedCart && typeof parsedCart === 'object') {
        parsedCart.toString = function() {
          return JSON.stringify(this);
        };
      }

      if (typeof cart === 'string') {
        return JSON.stringify(parsedCart);
      }
      return parsedCart;
    });
  };
})();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', main);
} else {

  requestAnimationFrame(main);
  document.addEventListener('DOMContentLoaded', main);
}


(function() {
  var CART_ADD_RE = /\/cart\/add/;
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || form.method !== 'post') return;
    var action = (form.action || form.getAttribute('action') || '').toLowerCase();
    if (!CART_ADD_RE.test(action)) return;
    
    if (e.defaultPrevented) return;
    
    if (form.dataset.submitting === 'true') return;

    e.preventDefault();

    var btn = form.querySelector('button[name="add"], [data-add-to-cart], .add-to-cart, [type="submit"]');
    form.dataset.submitting = 'true';
    if (btn) btn.classList.add('btn--loading');

    var url = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add';
    var body = new URLSearchParams(new FormData(form));

    fetch(url, {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      delete form.dataset.submitting;
      if (btn) btn.classList.remove('btn--loading');
      if (data && data.status !== 422) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data, addToCartBtn: btn }
        }));
      }
    })
    .catch(function() {
      delete form.dataset.submitting;
      if (btn) btn.classList.remove('btn--loading');
    });
  });
})();


(function() {
  function openCartDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    if (drawer.classList.contains('drawer--is-open') || drawer.classList.contains('is-visible')) return;
    document.dispatchEvent(new CustomEvent('cart:open'));
  }

  document.addEventListener('ajaxProduct:added', openCartDrawer);

  function getProductCard(btn) {
    var card = btn.closest('.rebuy-product-block, .rebuy-product-card, .rebuy-product-item, .rebuy-product-info');
    if (card && !card.classList.contains('rebuy-widget') && !card.classList.contains('rebuy-product-grid') && !card.classList.contains('rebuy-product-list')) {
      return card;
    }
    var curr = btn;
    var lastChild = btn;
    while (curr && curr.parentElement && curr.parentElement !== document.body) {
      var pCls = curr.parentElement.className || '';
      if (typeof pCls === 'string' && (pCls.indexOf('rebuy-product-grid') !== -1 || pCls.indexOf('rebuy-product-list') !== -1 || pCls.indexOf('rebuy-widget') !== -1 || curr.parentElement.hasAttribute('data-rebuy-id'))) {
        return curr;
      }
      lastChild = curr;
      curr = curr.parentElement;
    }
    return lastChild;
  }

  function getVariantFromRebuyGlobal(card, btn) {
    try {
      if (!window.Rebuy) return null;

      var linkEl = card ? card.querySelector('a[href*="/products/"]') : null;
      var handle = linkEl ? linkEl.getAttribute('href').split('/products/')[1].split('?')[0].split('#')[0].replace(/\/+$/, '') : null;
      var titleEl = card ? card.querySelector('.rebuy-product-title, [class*="product-title"]') : null;
      var title = titleEl ? titleEl.textContent.trim().toLowerCase() : null;
      var ariaLabel = btn.getAttribute('aria-label') || '';

      var widgets = window.Rebuy.widgets || {};
      var widgetKeys = Object.keys(widgets);

      function returnVariant(p) {
        var sel = card ? card.querySelector('select.rebuy-select, select') : null;
        if (sel && sel.value) return sel.value;
        if (p.selected_variant && p.selected_variant.id) return String(p.selected_variant.id);
        if (p.selectedVariant && p.selectedVariant.id) return String(p.selectedVariant.id);
        if (p.variants && p.variants.length > 0) return String(p.variants[0].id);
        return null;
      }

      /* Pass 1: high-confidence — handle or exact title match */
      for (var i = 0; i < widgetKeys.length; i++) {
        var w = widgets[widgetKeys[i]];
        if (!w || !w.data) continue;
        var prods = w.data.products || w.products || [];
        for (var j = 0; j < prods.length; j++) {
          var p = prods[j];
          if (!p) continue;
          if (handle && p.handle === handle) return returnVariant(p);
          if (title && p.title && p.title.trim().toLowerCase() === title) return returnVariant(p);
        }
      }

      /* Pass 2: low-confidence fallback — ariaLabel substring match */
      if (ariaLabel) {
        for (var i2 = 0; i2 < widgetKeys.length; i2++) {
          var w2 = widgets[widgetKeys[i2]];
          if (!w2 || !w2.data) continue;
          var prods2 = w2.data.products || w2.products || [];
          for (var j2 = 0; j2 < prods2.length; j2++) {
            var p2 = prods2[j2];
            if (!p2) continue;
            if (p2.title && ariaLabel.toLowerCase().indexOf(p2.title.trim().toLowerCase()) !== -1) {
              return returnVariant(p2);
            }
          }
        }
      }
    } catch (_) {}
    return null;
  }

  function getVariantIdFromCard(card, btn) {
    if (!card) return null;

    /* 1. Check select inside THIS card */
    var sel = card.querySelector('select.rebuy-select, select');
    if (sel) {
      if (sel.value) return sel.value;
      if (sel.options && sel.options.length > 0) {
        var idx = sel.selectedIndex >= 0 ? sel.selectedIndex : 0;
        if (sel.options[idx] && sel.options[idx].value) return sel.options[idx].value;
      }
    }

    /* 2. Check hidden inputs inside THIS card */
    var inp = card.querySelector('input[name="id"], input[name="variant_id"], input[type="hidden"]');
    if (inp && inp.value) return inp.value;

    /* 2b. Extract variant ID from product link URL (?variant=XXXXX) */
    var prodLink = card.querySelector('a[href*="/products/"]');
    if (prodLink) {
      var linkHref = prodLink.getAttribute('href') || '';
      var variantMatch = linkHref.match(/[?&]variant=(\d+)/);
      if (variantMatch && variantMatch[1]) return variantMatch[1];
    }

    /* 3. Walk up DOM tree from btn checking Vue instance (__vue__) */
    var curr = btn;
    while (curr && curr !== document.body) {
      try {
        var vue = curr.__vue__ || curr.__vueParentComponent;
        if (vue) {
          var target = vue.product || vue.item || (vue.$data && vue.$data.product) || (vue.ctx && vue.ctx.product) || vue.$data || vue.ctx;
          if (target) {
            if (target.selected_variant && target.selected_variant.id) return String(target.selected_variant.id);
            if (target.selectedVariant && target.selectedVariant.id) return String(target.selectedVariant.id);
            if (target.variant_id) return String(target.variant_id);
            if (target.variantId) return String(target.variantId);
            if (target.variants && target.variants.length > 0) {
              var vIdx = target.selected_variant_index || 0;
              if (target.variants[vIdx] && target.variants[vIdx].id) return String(target.variants[vIdx].id);
            }
          }
        }
      } catch (_) {}
      curr = curr.parentElement;
    }

    /* 4. Check Rebuy global JS data matching handle/title/aria-label */
    var globalVid = getVariantFromRebuyGlobal(card, btn);
    if (globalVid) return globalVid;

    /* 5. Check data attributes on card or parents */
    curr = btn;
    while (curr && curr !== document.body) {
      var dVid = curr.getAttribute('data-variant-id') || curr.getAttribute('data-id') || curr.getAttribute('data-rebuy-variant-id');
      if (dVid) return dVid;
      curr = curr.parentElement;
    }

    return null;
  }

  function addVariantToCart(vid, btn, origHTML) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(vid), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = origHTML;
      }
      openCartDrawer();
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: data, addToCartBtn: btn }
      }));
    })
    .catch(function(err) {
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = origHTML;
      }
      openCartDrawer();
    });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target && e.target.closest && e.target.closest('button.rebuy-button, .rebuy-button');
    if (!btn) return;

    var txt = (btn.textContent || '').trim().toLowerCase();
    if (txt.indexOf('add') === -1) return;
    if (txt.indexOf('choose') !== -1 || txt.indexOf('select') !== -1 || txt.indexOf('option') !== -1) return;

    /* Intercept and stop default navigation IMMEDIATELY */
    e.stopImmediatePropagation();
    e.preventDefault();
    e.stopPropagation();

    var card = getProductCard(btn);
    var vid = getVariantIdFromCard(card, btn);

    var origHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span>Adding…</span>';

    if (vid) {
      addVariantToCart(vid, btn, origHTML);
    } else {
      /* Async fallback: fetch product handle JSON */
      var linkEl = card ? card.querySelector('a[href*="/products/"]') : null;
      var handle = linkEl ? linkEl.getAttribute('href').split('/products/')[1].split('?')[0].split('#')[0].replace(/\/+$/, '') : null;

      if (handle) {
        fetch('/products/' + handle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(pData) {
            if (pData && pData.variants && pData.variants.length > 0) {
              addVariantToCart(pData.variants[0].id, btn, origHTML);
            } else {
              btn.disabled = false;
              btn.innerHTML = origHTML;
              openCartDrawer();
            }
          })
          .catch(function() {
            btn.disabled = false;
            btn.innerHTML = origHTML;
            openCartDrawer();
          });
      } else {
        btn.disabled = false;
        btn.innerHTML = origHTML;
        openCartDrawer();
      }
    }
  }, true);
})();

window.__auCart = {
  main: main,
  wireCart: wireCart,
  autoFreeGifts: autoFreeGifts,
  autoFreeGiftsFresh: autoFreeGiftsFresh,
};